<template>
  <Presentershero />
  <section class="presenters">
    <div class="presenters__content container">
      <h2 class="presenters__uptitle">
        GET TO KNOW
      </h2>
      <h2 class="presenters__title">
        This Year's Lineup
      </h2>
      <hr class="half-line" />
      <input
        type="text"
        v-model="searchQuery"
        placeholder="SEARCH COMPANY BY NAME"
        class="presenters__search"
      />
      <div v-if="filteredLogos.length > 0" class="presenters__cards">
        <div
          class="presenters__item"
          v-for="(logo, index) in filteredLogos"
          :key="index"
          :class="logo.class"
        >
          <div class="presenters__item--info">
            <div class="titles">
              <h2>{{ logo.name }}</h2>
              <p>{{ logo.market }}<template v-if="logo.ticker">:</template> {{ logo.ticker }} </p>
            </div>
          </div>
          <div class="presenters__item--logo">
            <img :src="logo.url" :alt="logo.name">
          </div>
          <div class="presenters__item--btn">
            <a v-if="logo.path" :href="logo.path" target="_blank">
              <button class="btn-new-alt">
                View Company
              </button>
            </a>
          </div>
        </div>
      </div>
      <p v-else class="no-matches">No matches found for your search.</p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/presenters.scss';
</style>

<script>
import Presentershero from '../components/presentershero.vue';

export default {
  name: 'presenters',
  data() {
    return {
      searchQuery: '',
      logos: [
        { url: require('../assets/presenters/jaguar.png'),
          name: 'Jaguar Health, Inc.', class: 'jaguar',
          market: 'NASDAQ', ticker: 'JAGX',
          path: 'https://jaguarhealth.gcs-web.com/'
        },
        { url: require('../assets/presenters/mindwalk.png'),
          name: 'MindWalk', class: 'mindwalk',
          market: 'NASDAQ', ticker: 'HYFT',
          path: 'https://www.mindwalkai.com/'
        },
        { url: require('../assets/presenters/trx.svg'),
          name: 'TRX Gold', class: 'trx',
          market: 'NYSEAMERICAN', ticker: 'TRX',
          path: 'https://trxgold.com/'
        },
        { url: require('../assets/presenters/stewards.png'),
          name: 'Stewards, Inc.', class: 'stewards',
          market: 'OTC', ticker: 'SWRD',
          path: 'https://stewards.com/'
        },
        { url: require('../assets/presenters/oragenics.svg'),
          name: 'Oragenics, Inc.', class: 'oragenics',
          market: 'NYSE', ticker: 'OGEN',
          path: 'https://www.oragenics.com/'
        },
        { url: require('../assets/presenters/metavesco.png'),
          name: 'Metavesco', class: 'metavesco',
          market: 'OTC', ticker: 'MVCO',
          path: 'https://metavesco.com/'
        },
        { url: require('../assets/presenters/auddia.svg'),
          name: 'Auddia Inc', class: 'auddia',
          market: 'NASDAQ', ticker: 'AUUD',
          path: 'https://www.auddia.com/'
        },
        { url: require('../assets/presenters/aclarion.png'),
          name: 'Aclarion, Inc', class: 'aclarion',
          market: 'NASDAQ', ticker: 'ACON',
          path: 'https://aclarion.com/'
        },
        { url: require('../assets/presenters/charlies.png'),
          name: "Charlie's Holdings, Inc.", class: 'charlies',
          market: 'OTC', ticker: 'CHUC',
          path: 'https://charliesholdings.com/'
        },
        { url: require('../assets/presenters/ederra.png'),
          name: 'Ederra', class: 'ederra',
          market: 'Private', ticker: '',
          path: 'https://ederralyfe.com/'
        },
        { url: require('../assets/presenters/humla.png'),
          name: 'Humla Ventures', class: 'humla',
          market: 'Private', ticker: '',
          path: 'https://www.humla.vc/'
        },
        { url: require('../assets/presenters/adaptin.png'),
          name: 'Adaptin', class: 'adaptin',
          market: 'Private',
          path: 'https://adaptinbio.com/'
        },
        { url: require('../assets/presenters/society.webp'),
          name: 'Society Pass Incorporated', class: 'society',
          market: 'NASDAQ', ticker: 'SOPA',
          path: 'https://www.thesocietypass.com/'
        },
        { url: require('../assets/presenters/gotv.svg'),
          name: 'FullPac', class: 'gotv',
          market: 'NASDAQ', ticker: 'GOTV',
          path: 'https://gotv.com/'
        },
        { url: require('../assets/presenters/firstp.png'),
          name: 'First Phosphate', class: 'phos',
          market: 'CSE', ticker: 'PHOS',
          path: 'https://firstphosphate.com/'
        },
        { url: require('../assets/sponsors/axe.png'),
          name: 'AXE Compute', class: 'axe',
          market: 'NASDAQ', ticker: 'AGPU',
          path: 'https://axecompute.com/'
        },
        { url: require('../assets/presenters/gpo.png'),
          name: 'GPO Plus Inc', class: 'gpo',
          market: 'OTCMKTS', ticker: 'GPOX',
          path: 'https://gpoplus.com/'
        },
        { url: require('../assets/presenters/principled.svg'),
          name: 'Principled Business', class: 'prbs',
          market: 'Private',
          path: 'https://www.principledbusiness.org/'
        },
        { url: require('../assets/presenters/taoshi.svg'),
          name: 'Taoshi', class: 'taoshi',
          market: 'Private',
          path: 'https://www.taoshi.io/'
        },
        { url: require('../assets/presenters/zhittya.png'),
          name: 'Zhittya Genesis Medicine', class: 'zhittya',
          market: 'Private',
          path: 'https://www.zgm.care/'
        },
        { url: require('../assets/presenters/rocktech.svg'),
          name: 'Rock Tech Lithium Inc.', class: 'rocktech',
          market: 'OTCMKTS', ticker: 'RCKTF',
          path: 'https://rocktechlithium.com/'
        },
        { url: require('../assets/presenters/circadian.svg'),
          name: 'Circadian Group', class: 'circadian',
          market: 'Private',
          path: 'https://www.circadian-group.com/'
        },
        { url: require('../assets/presenters/liberty.svg'),
          name: 'Liberty Ventures', class: 'liberty',
          market: 'Private',
          path: 'https://www.libertyventuresnetwork.com/'
        },
        { url: require('../assets/presenters/xset.png'),
          name: 'XSET', class: 'xset',
          market: 'Private',
          path: 'https://xset.com/'
        },
        { url: require('../assets/presenters/elauwit.png'),
          name: 'Elauwit', class: 'elauwit',
          market: 'NASDAQ', ticker: 'ELWT',
          path: 'https://elauwit.com/'
        },
        { url: require('../assets/presenters/wirenetwork.svg'),
          name: 'Wire Network', class: 'wirenet',
          market: 'Private',
          path: 'https://www.wire.network/'
        },
        { url: require('../assets/presenters/gamesquare.png'),
          name: 'GameSquare', class: 'gamesq',
          market: 'NASDAQ', ticker:'GAME',
          path: 'https://www.gamesquare.com/'
        },
        { url: require('../assets/presenters/newton.png'),
          name: 'Newton Golf Co', class: 'newton',
          market: 'NASDAQ', ticker:'NWTG',
          path: 'https://newtongolfco.com/'
        },
        { url: require('../assets/presenters/toke.svg'),
          name: 'Toke LLC', class: 'toke',
          market: 'Private',
          path: 'https://www.gotokes.com/'
        },
        { url: require('../assets/presenters/canstar.png'),
          name: 'Canstar Resources', class: 'rox',
          market: 'TSXV', ticker: 'ROX',
          path: 'https://www.canstarresources.com/'
        },
        { url: require('../assets/presenters/realbricks.svg'),
          name: 'Realbricks', class: 'realbricks',
          market: 'Private',
          path: 'https://www.realbricks.com/'
        },
        { url: require('../assets/presenters/manifest.png'),
          name: 'Manifest Network', class: 'manifest',
          market: 'Private',
          path: 'https://manifest.network/'
        },
        { url: require('../assets/presenters/circlelife.png'),
          name: 'Circle Life', class: 'circle',
          market: 'Private',
          path: 'https://circlelife.health/'
        },
        { url: require('../assets/presenters/wellgistics.png'),
          name: 'Wellgistics Health', class: 'wellgistics',
          market: 'NASDAQ', ticker: 'WGRX',
          path: 'https://wellgisticshealth.com/'
        },
        { url: require('../assets/presenters/akupara.png'),
          name: 'Akupara Adventures', class: 'akupara',
          market: 'Private',
          path: 'https://www.akuparaadventures.com/'
        },
      ],
    };
  },
  components: {
    Presentershero
  },
  computed: {
    filteredLogos() {
      const query = this.searchQuery.toLowerCase();
      return this.logos.filter((logo) =>
        logo.name.toLowerCase().includes(query) || 
        (logo.ticker && logo.ticker.toLowerCase().includes(query))
      );
    },
  },
};
</script>